module.exports = __webpack_public_path__ + "img/big_1_23.10e54f59.png";